import {
  finalConfig,
  currentEnvironment,
  isDevelopment,
  isProduction,
  isTest,
} from '../../config/environments';

// Re-export environment configuration
export const ENVIRONMENT = currentEnvironment;
export const MOCK_MODE = finalConfig.MOCK_MODE;
export const ENABLE_ANALYTICS = finalConfig.ENABLE_ANALYTICS;
export const ENABLE_CRASH_REPORTING = finalConfig.ENABLE_CRASH_REPORTING;
export const GOOGLE_ANALYTICS_ID = finalConfig.GOOGLE_ANALYTICS_ID;
export const GOOGLE_TAG_MANAGER_ID = finalConfig.GOOGLE_TAG_MANAGER_ID;
export const META_PIXEL_ID = finalConfig.META_PIXEL_ID;
export const DEBUG_API = finalConfig.DEBUG_API;
export const TIMEOUTS = finalConfig.TIMEOUTS;

// Backend API Configuration - use configuration from environment config
export const API_URL = finalConfig.API_URL;

// App configuration
export const APP_NAME =
  (process.env.EXPO_PUBLIC_APP_NAME as string) || 'Coloursense';
export const APP_VERSION = '1.0.0';

// API Configuration
export const API_CONFIG = {
  baseURL: API_URL,
  timeout: finalConfig.TIMEOUTS.API_REQUEST,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ME: '/auth/me',
    REFRESH: '/auth/refresh',
  },
  // Users
  USERS: {
    LIST: '/users',
    PROFILE: '/users/profile',
    UPDATE: '/users/update',
  },
  // Colours
  COLOURS: {
    ANALYZE: '/colours/analyze',
    LIST: '/colours',
    GET: '/colours',
    DELETE: '/colours',
  },
  // Mood Boards
  MOOD_BOARDS: {
    LIST: '/mood-boards',
    CREATE: '/mood-boards',
    GET: '/mood-boards',
    UPDATE: '/mood-boards',
    DELETE: '/mood-boards',
    LIKE: '/mood-boards/:id/like',
    PUBLIC: '/mood-boards/community/public',
  },
  // Onboarding
  ONBOARDING: {
    COMPLETE: '/onboarding/complete',
    STATUS: '/onboarding/status',
    TOUR_COMPLETE: '/onboarding/tour-complete',
  },
  // Subscriptions
  SUBSCRIPTIONS: {
    STATUS: '/subscriptions/status',
    UPGRADE: '/subscriptions/upgrade',
    DOWNGRADE: '/subscriptions/downgrade',
    RESTORE: '/subscriptions/restore',
  },
  // Health check
  HEALTH: '/health',
};

// httpOnly cookie auth - when true on web, tokens not stored in localStorage (XSS-safe)
export const USE_HTTPONLY_COOKIES = finalConfig.USE_HTTPONLY_COOKIES ?? false;

// Environment-specific settings from config
export const ENV_SETTINGS = {
  logLevel: finalConfig.LOG_LEVEL,
  enableHotReload: finalConfig.ENABLE_HOT_RELOAD,
  showDevWarnings: finalConfig.SHOW_DEV_WARNINGS,
  cacheTimeout: finalConfig.CACHE_TIMEOUT,
};

// Logging configuration
export const shouldLog = (level: 'debug' | 'info' | 'warn' | 'error') => {
  const levels = { debug: 0, info: 1, warn: 2, error: 3 };
  const currentLevel =
    levels[ENV_SETTINGS.logLevel as keyof typeof levels] || 0;
  return levels[level] >= currentLevel;
};

// Re-export environment check helpers
export { isDevelopment, isProduction, isTest };

// Note: Mock mode is disabled by default since database is working
// To enable mock mode for testing: set EXPO_PUBLIC_MOCK_MODE="true"
